import React, { useEffect, useState } from 'react';

const UserContext = React.createContext('');

const UserProvider = (props) => {
    const [isLogin, setIsLogin] = useState(false);

    useEffect(() => {
        const isLogin = localStorage.getItem('token');
        setIsLogin(!!isLogin);
    }, []);

    const handleLogin = (token) => {
        setIsLogin(true);
        localStorage.setItem('token', token);
    };

    const handleLogOut = () => {
        setIsLogin(false);
        localStorage.removeItem('token');
    };

    return (
        <UserContext.Provider
            value={{
                isLogin: isLogin,
                handleLogin,
                handleLogOut,
            }}
        >
            {props.children}
        </UserContext.Provider>
    );
};

export { UserContext, UserProvider };
